export const API_URL = process.env.TZB_API_PUB || 'https://api.cnosfap.net/tzb'
export const TZB_WEB_PUB =
  process.env.TZB_WEB_PUB || 'https://tazebao.cnosfap.net'
export const TZB_MOBILE_PUB =
  process.env.TZB_MOBILE_PUB || 'https://tazebao.cnosfap.net/presenze'

export const COOKIE_DOMAIN = process.env.COOKIE_DOMAIN || '.cnosfap.net'



// WEBPACK FOOTER //
// ./src/service/config.js